import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubSectionSelect]'})
export class SectionSelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
